import { api } from "./client";
import { Post } from "./posts";
import { Comment } from "./comments";

export type UserProfile = {
    user_id: number;
    username: string;
    avatar_url: string;
    created_at: string;
    post_count: number;
    comment_count: number;
    vote_count: number;
};

export async function getMyProfile() {
    return api<UserProfile>("/users/me", "GET", undefined, true);
}

export async function getMyPosts() {
    return api<Post[]>("/users/me/posts", "GET", undefined, true);
}

export async function getMyComments() {
    return api<Comment[]>("/users/me/comments", "GET", undefined, true);
}

export async function getMyUpvotedPosts() {
    return api<Post[]>("/users/me/upvoted", "GET", undefined, true);
}
